<!-- This templates insert a chunck if the var is defined -->
<template>
  <tr v-if="this.condition()">
    <td>
      <v-icon v-if="icon"> {{ this.icon }}</v-icon>
      {{ this.prefix }}
    </td>
    <td v-if="this.displayLink()">
      <a :href="this.displayLink()" target="_blank">
        {{
          this.displayText()
        }}
        {{this.suffix}}
      </a>
    </td>
    <td v-if="this.href==null">{{
        this.displayText()
      }}
    </td>
  </tr>
</template>

<script>
export default {
  name: "SimpleTr",
  props: {
    var: {},
    data: {},
    alt_data:{},
    field: {},
    showifempty: {default: false},
    icon: {},
    prefix: {
      default: "",
    },
    suffix: {
      default: "",
    },
    href: {},
    value:{}
  },
  methods: {
    condition() {
      if (this.value) {
        return true
      }
      if (!this.var) {
        return false;
      }
      if (!this.data) {
        return false;
      }
      if (!(this.data in this.var) &&!(this.alt_data in this.var) ) {
        return false;
      }
      return this.value || this.showifempty || this.getData(this.field) || (this.field == "mix" &&  this.getData() );
    },
    displayLink() {
      if (this.href ==null || this.href=="") {
        return null
      }
      if (this.href=="mailto") {
        return "mailto:"+this.getData("valeur")
      }
      if (this.href == "valeur") {
        return this.getData("valeur")
      }
      if (this.href == "libelle") {
        return this.getData("libelle")
      }
      return this.href
    },
    getData(field=null) {
      if (field=="mix") { field="valeur"}
      if (field==null) {
        if (this.data in this.var && this.var[this.data] ) {
          return this.var[this.data]
        } else {
           return this.var[this.alt_data]
        }
      }
      //console.log(this.data + " : "  + " / " + this.alt_data +" ; " )
      if (this.data in this.var && this.var[this.data] && this.var[this.data][field] != null && this.var[this.data][field]!="") {
        //console.log("data")
        return this.var[this.data][field];
      } else if (this.alt_data && this.alt_data in this.var) {
        return this.var[this.alt_data][field]
      } else {
        return null
      }
    },
    displayText() {

      if (this.data == "evolutionEffectif") {
        var arr = this.getData("valeur")
        var lastYear = Math.max.apply(Math, arr.map(function(o) { return o.annee; }))
        for (var idx in arr) {
          if (arr[idx]['annee'] == lastYear)
            return arr[idx]['annee'] + " : " + arr[idx]['effectif']
        }
        return -1
      }

      if (this.value) {
        return this.value+ this.suffix
      }
      if (this.field && this.field == "mix") {
        return (
            this.getData("libelle") +
            "(" +
            this.getData("valeur") +
            ")" + this.suffix
        );
      }
      if (!this.field || !(this.field in this.getData())) {
        return this.getData() + this.suffix;
      }
      return this.getData()[this.field] + this.suffix;
    },
    displayIcon() {

      if (!this.icon) return "";
      return "fa fa-" + this.icon;
    },
  },
};
</script>
